import Http from '../../../../network/Http';
import {NatGetSutekiNetPlus} from './NatGetSutekiNetPlus';

export default class NatSutekiNetPlusRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http;
    }

    // 素敵ネットプラスバナー情報
    async getSutekiNetPlus(): Promise<NatGetSutekiNetPlus> {
        return await this.http.get('/api/resident/sutekiNetPlus');
    }
}
